// extracted by mini-css-extract-plugin
module.exports = {"ImageContainer":"Static_ImageContainer__2Nja4","staticdata":"Static_staticdata__3hsue","be_better_section":"Static_be_better_section__1pzjl","container":"Static_container__2p-T5"};